// extracted by mini-css-extract-plugin
export default {"services-section":"services-section_services-section__Znhxn","svg-container":"services-section_svg-container__odQBi"};